import { ModalForm } from '@ant-design/pro-components';
import { useModel } from '@umijs/max';
import { Tag, message } from 'antd';
import { createStyles } from 'antd-style';
import React, { useState } from 'react';
import { selectIdentity } from '@/services/login/api';
import { Key, getCookie, setCookie } from '@/utils/cookie';

const useStyles = createStyles(({ token }) => {
  return {
    identityCard: {
      padding: '16px',
      marginBottom: 12,
      borderRadius: token.borderRadius,
      border: `1px solid ${token.colorBorderSecondary}`,
      cursor: 'pointer',
      transition: 'all 0.3s',
      backgroundColor: token.colorBgContainer,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      '&:hover': {
        borderColor: token.colorPrimary,
        boxShadow: token.boxShadowSecondary,
        transform: 'translateY(-2px)',
      },
    },
    identityName: {
      fontSize: 16,
      fontWeight: 500,
      color: token.colorTextHeading,
      marginBottom: 8,
    },
    identityDesc: {
      fontSize: 14,
      color: token.colorTextSecondary,
    },
  };
});

type SwitchIdentityModalProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
};

const SwitchIdentityModal: React.FC<SwitchIdentityModalProps> = ({ open, onOpenChange }) => {
  const { styles } = useStyles();
  const { initialState } = useModel('@@initialState');
  const [identityLoading, setIdentityLoading] = useState<boolean>(false);
  const currentUser = initialState?.currentUser;

  const handleSelectIdentity = async (identity: UserAPI.IdentityItem) => {
    setIdentityLoading(true);
    try {
      const token = getCookie(Key.ATK);
      if (!token) return;
      const res = await selectIdentity({ accessToken: token, pid: identity.pid });
      if (res.accessToken) {
        setCookie(Key.ATK, res.accessToken);
        onOpenChange(false);
        message.success('切换身份成功！');
        if (initialState?.fetchUserInfo) {
          await initialState.fetchUserInfo();
        }
        window.location.reload();
      }
    } catch (e) {
      // 错误由拦截器处理
    } finally {
      setIdentityLoading(false);
    }
  };

  return (
    <ModalForm
      title="请选择要切换的身份"
      open={open}
      onOpenChange={onOpenChange}
      width={480}
      submitter={false}
      modalProps={{ destroyOnClose: true }}
    >
      <div style={{ maxHeight: '400px', overflowY: 'auto', padding: '4px 8px 4px 4px', marginTop: 16 }}>
        {currentUser?.identities?.map((item) => (
          <div
            key={item.pid}
            className={styles.identityCard}
            onClick={() => !identityLoading && currentUser?.pid !== item.pid && handleSelectIdentity(item)}
            style={{ 
              opacity: identityLoading ? 0.6 : 1, 
              cursor: (identityLoading || currentUser?.pid === item.pid) ? 'not-allowed' : 'pointer',
              borderColor: currentUser?.pid === item.pid ? '#1677ff' : undefined
            }}
          >
            <div style={{ flex: 1 }}>
              <div className={styles.identityName}>
                {item.name} 
                {currentUser?.pid === item.pid && <Tag color="blue" style={{ marginLeft: 8 }}>当前使用</Tag>}
              </div>
              <div className={styles.identityDesc}>
                {item.deptName || '未分配部门'}
              </div>
            </div>
            <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap', justifyContent: 'flex-end', maxWidth: '50%' }}>
              {item.roleNames?.map((role) => (
                <Tag key={role} color="blue" style={{ margin: 0 }}>{role}</Tag>
              ))}
            </div>
          </div>
        ))}
      </div>
    </ModalForm>
  );
};

export default SwitchIdentityModal;
